import React, { useEffect, createElement } from 'react';
export function MetaPixel() {
  useEffect(() => {
    const pixelId = '1252242806993118';
    if (typeof window === 'undefined') return;
    const w = window as any;
    // Initialize fbq stub safely
    if (!w.fbq) {
      const n: any = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      w.fbq = n;
      if (!w._fbq) w._fbq = n;
      // Inject the script tag safely (append to head/body, no parentNode assumption)
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const target = document.head || document.body || document.documentElement;
      if (target) target.appendChild(script);
    }
    w.fbq('init', pixelId);
    w.fbq('track', 'PageView');
  }, []);
  return null;
}